"use client";

import { Suspense } from "react";

import type { BuilderBlock, BuilderContextInterface, RegisteredComponents } from "@builder.io/sdk-react";
import { Blocks, isPreviewing } from "@builder.io/sdk-react";

import { useConfig } from "@jti/app-context/useConfig";
import { SecondaryNavigation as UISecondaryNavigation } from "@jti/ui/eva-components/Header/components/SecondaryNavigation/SecondaryNavigation";
import { HeaderProvider as UIHeaderProvider } from "@jti/ui/eva-components/Header/context";
import { SecondaryNavigation as MobileFirstUISecondaryNavigation } from "@jti/ui/eva-components/MobileFirstHeader/components/SecondaryNavigation";
import { HeaderProvider as MobileFirstHeaderProvider } from "@jti/ui/eva-components/MobileFirstHeader/context";

type SecondaryNavigationProps = {
  builderBlock: BuilderBlock;
  builderContext: BuilderContextInterface;
  builderComponents: RegisteredComponents;
};

export function SecondaryNavigation(props: SecondaryNavigationProps) {
  return (
    <Suspense>
      <SecondaryNavigationContent {...props} />
    </Suspense>
  );
}

function SecondaryNavigationContent({ builderBlock, builderContext, builderComponents }: SecondaryNavigationProps) {
  const { isMobileFirstNavigationEnabled } = useConfig();

  const SecondaryNavigationComponent = isMobileFirstNavigationEnabled
    ? MobileFirstUISecondaryNavigation
    : UISecondaryNavigation;

  const blocks = builderBlock?.children?.map((child) => (
    <Blocks
      key={child.id}
      blocks={[child]}
      parent={builderBlock?.id}
      path="children"
      context={builderContext}
      registeredComponents={builderComponents}
    />
  ));

  if (isPreviewing()) {
    const HeaderProvider = isMobileFirstNavigationEnabled ? MobileFirstHeaderProvider : UIHeaderProvider;
    return (
      <HeaderProvider>
        <SecondaryNavigationComponent>{blocks}</SecondaryNavigationComponent>
      </HeaderProvider>
    );
  }
  return <SecondaryNavigationComponent>{blocks}</SecondaryNavigationComponent>;
}
